export enum GuideStep {
  MENU = 'MENU',
  ADD_PARKING = 'ADD_PARKING',
  FILTER = 'FILTER',
  ADDRESS_SEARCH = 'ADDRESS_SEARCH',
  FIND_NEAREST = 'FIND_NEAREST',
  MAP_POINT = 'MAP_POINT',
  SHEET_NAVIGATE = 'SHEET_NAVIGATE',
  SHEET_REVIEWS = 'SHEET_REVIEWS',
}
